import { useEffect, useState } from 'react';

export function useKeyboardOffset() {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const onResize = () => {
      const vv = window.visualViewport;
      if (vv) {
        const keyboardHeight = window.innerHeight - vv.height;
        setOffset(keyboardHeight > 150 ? keyboardHeight : 0);
      }
    };
    window.visualViewport?.addEventListener('resize', onResize);
    return () => window.visualViewport?.removeEventListener('resize', onResize);
  }, []);

  return offset;
} 